import React, { useState } from "react";
import "./Service_Card.css";
import Read_More_btn from "../../common-btn/redirect-btn/read-more-btn/Read_More_btn";
import { Link } from "react-router-dom";

const Service_Card = ({ title, description, icon, hoverImg, list }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={`service_card ${isHover ? "hover" : ""}`}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="service-card-content">
        <div className="service_title">
          <span className="bullet"></span>
          <h5 className="service-card-title">{title}</h5>
        </div>

        <p className="service-card-description">{description}</p>
        
        {list && list.length > 0 && (
          <ul className="service-card-list">
            {list.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}

        <div className="card_image_holder">
          <img src={icon} alt="service icon" className="bottom_img" />
        </div>

        {/* <div className="read_more">
          <Link to="/services/service-detail" className="service_card_link">
            <Read_More_btn link="/services/service-detail" />
          </Link>
        </div> */}
      </div>

      <div className="img_holder">
        <div className="inner_img_div">
          <img
            src={process.env.PUBLIC_URL + hoverImg}
            alt={title}
            className="hover_img"
          />
        </div>
      </div>
    </div>
  );
};

export default Service_Card;